import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { axios, errorResponse } from "../../helpers";
import { loginData, logout } from "../../stores/auth";

const UsePutDataForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dataLogin = useSelector(loginData);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handlePutDataForm = async (params) => {
    setIsLoading(true);
    try {
      const bodyFormData = new FormData();
      Object.keys(params.form).map(function (key, index) {
        if (Array.isArray(params.form[key])) {
          if (params.form[key].length) {
            params.form[key].map((data) => {
              if (key === "images") {
                bodyFormData.append(`${key}`, data);
              } else {
                bodyFormData.append(`${key}[]`, data);
              }
            });
          } else {
            if (key === "images") {
              bodyFormData.append(`${key}`, "");
            } else {
              bodyFormData.append(`${key}[]`, "");
            }
          }
        } else {
          bodyFormData.append(key, params.form[key]);
        }
      });

      const response = await axios.put(params.url, bodyFormData, {
        headers: { Authorization: `Bearer ${dataLogin.data.token}` },
      });
      if (response.data.status) {
        swal("Berhasil", response.data.message, "success", {
          button: "Tutup",
        }).then(() => {
          setError("");
          if (params.navigation) {
            navigate(params.navigation, { replace: true });
          } else {
            window.location.reload();
          }
        });
      } else {
        swal("Error", response.data.message, "error");
        setError(response.data.message);
      }
    } catch (err) {
      if (errorResponse(err) == "jwt expired") {
        dispatch(logout());
      } else {
        setError(errorResponse(err));
        swal("Error", errorResponse(err), "error");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    handlePutDataForm,
  };
};

export default UsePutDataForm;
